class LoadIframe {
	
	/**
	 * Loading iframe from YouTube
	 */
	static loadIframe(iframeLoaded, videoPlaceholder, videoId) {
		if (iframeLoaded) return;
		
		const iframe = document.createElement('iframe');
		iframe.src = `https://www.youtube-nocookie.com/embed/${ videoId }`;
		iframe.frameBorder = '0';
		iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"';
		iframe.allowFullscreen = true;
		if (iframe) {
			videoPlaceholder.appendChild(iframe);
		}
		iframeLoaded = true;
		return iframeLoaded;
	}
}

module.exports = LoadIframe;

